import hostname from './config.host';
import { fetchWrapper } from './fetch-wrapper';
const apiUrl: string = `${hostname}/aladdin_api/v1`;

function getQuarterlyGoals(
  oauthTokenHeader: string,
  website_shared_uid: string
) {
  return fetchWrapper.get(
    `${apiUrl}/asset_management/health/quarterly_goal/${website_shared_uid}/`,
    oauthTokenHeader
  );
}

function createQuarterlyGoals(
  oauthTokenHeader: any,
  website_shared_uid: any,
  data: any
) {
  return fetchWrapper.post(
    `${apiUrl}/asset_management/health/quarterly_goal/${website_shared_uid}/`,
    data,
    oauthTokenHeader
  );
}

function editQuarterlyGoals(
    oauthTokenHeader: any,
    website_shared_uid: any,
    data: any
  ) {
    return fetchWrapper.put(
      `${apiUrl}/asset_management/health/quarterly_goal/${website_shared_uid}/`,
      data,
      oauthTokenHeader
    );
  }

  function getDevices(oauthTokenHeader: string) {
    return fetchWrapper.get(`${apiUrl}/meta/devices/`, oauthTokenHeader);
  }

  function getPageViewInternalList(
    oauthTokenHeader: string,
    website_shared_uid: any
  ) {
    return fetchWrapper.get(
      `${apiUrl}/asset_management/health/pagespeed_tests/${website_shared_uid}/`,
      oauthTokenHeader
    );
  }

  function putTogglePageSpeed(
    oauthTokenHeader: string,
    data: any,
    website_shared_uid: any,
    psi_shared_uid: any
  ) {
    return fetchWrapper.put(
      `${apiUrl}/asset_management/health/pagespeed_tests/${website_shared_uid}/?psi=${psi_shared_uid}`,
      data,
      oauthTokenHeader
    );
  }

  function postPageSpeedInternal(
    oauthTokenHeader: string,
    data: any,
    website_shared_uid: any
  ) {
    return fetchWrapper.post(
      `${apiUrl}/asset_management/health/pagespeed_tests/${website_shared_uid}/`,
      data,
      oauthTokenHeader
    );
  }

export const quarterlySpeedGoalsService = {   
    getQuarterlyGoals,
    createQuarterlyGoals,
    editQuarterlyGoals,
    getDevices,
    getPageViewInternalList,
    putTogglePageSpeed,
    postPageSpeedInternal
}
